import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { BsChevronDown } from 'react-icons/bs';

import './NextStory.scss';
import { useMediaQuery } from 'react-responsive';
import Credits from '../Credits/Credits';
import { ADAARIARoles, ADALandmarks } from '../../../models/ADA';

const NextStory = ({ title, subtitle, next, showNext, showCredits, onCreditsClick }) => {
  const isPortrait = useMediaQuery({ query: '(max-width: 767px)' });
  const menuOpened = useSelector(state => state.data.menuOpened);
  const handleCreditsClick = (active) => {
    onCreditsClick(active);
  };

  const timeout = (delay) => {
    return new Promise( res => setTimeout(res, delay) );
}

  async function refreshPage () {
    await timeout(100);
    window.location.reload(false);
  }


  return (
    <div className="pbp-bottom-nav" >
      <div className={`pbp-bn-hover-area ${showNext ? 'active' : ''}`}>
        <div className="pbp-bn-full-content" role={ADAARIARoles.Navigation} aria-label="Bottom of the page">
          <div className="pbp-bn-grid-content cpvi-grid-container">
            <div className="pbp-bn-link-wrapper cpvi-grid-col">
              <Link className="pbp-bn-link" to={next} onClick={refreshPage} tabIndex={menuOpened ? -1 : 0}>
                <div className="pbp-bn-link-title" >{title}</div>
                {!isPortrait ? <div className="ada-hidden">:</div> : null}
                {!isPortrait ? <div className="pbp-bn-link-subtitle">{subtitle}</div> : null}
              </Link>
            </div>
          </div>
        </div>
        <Credits showBar={showCredits} onClick={handleCreditsClick} isLightBg={true} />
      </div>
    </div>
  );
};

export default NextStory;
